import { useEditorAccess } from 'flow/editor/context';
import { EditorMode } from 'flow/editor/context/constants';

export function useHandleDiffMode() {
  const { setEditorMode } = useEditorAccess();

  return () => {
    setEditorMode(EditorMode.ReadOnly);
  };
}
